import type { SocialLinkField } from '../lib/social-links';

const ICON_PATHS: Record<SocialLinkField, readonly string[]> = {
  websiteUrl: [
    'M2 12a10 10 0 1 0 20 0a10 10 0 1 0-20 0',
    'M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20',
    'M2 12h20',
  ],
  facebookUrl: ['M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z'],
  instagramUrl: [
    'M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5z',
    'M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z',
    'M17.5 6.5h.01',
  ],
  tiktokUrl: ['M9 12a4 4 0 1 0 4 4V2a5 5 0 0 0 5 5'],
};

export function SocialPlatformIcon({ field }: { field: SocialLinkField }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={24}
      height={24}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ICON_PATHS[field].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
